export default [
  {
    title: 'Application Security',
    items: [
      {
        title: 'DDOS and Rate Limiting',
        text: [
          'All MikMak applications are protected against DDoS attacks that would result in downtime. We also enforce rate limiting on all of our services in order to avoid nefarious traffic that might otherwise interrupt our services.'
        ]
      },
      {
        title: 'Incident reporting & Logging',
        text: [
          'Access history and all incidents are logged and available to the relevant MikMak team members.',
          'In the rare event of downtime or any other incident with our applications, clients will be notified immediately, updated every hour during the incident, and notfied again upon resolution of the incident.'
        ]
      },
      {
        title: 'Uptime',
        text: [
          'MikMak Applications have an uptime of 99.95% or higher.'
        ]
      },
      {
        title: 'SSO & 2FA',
        text: [
          'All applications within our platform are secured by accounts with two factor authentication enabled. We also leverage Single Sign On in all applications, in order to reduce the number of credentials that need securing.'
        ]
      },
      {
        title: 'Audits',
        text: [
          'MikMak is periodically audited via penetration testing for security vulnerabilities. We immediately address any issues discovered during these audits.',
          'We reguarly self-audit for compliance with OWASP Top 10 security guidelines.'
        ]
      }
    ]
  },
  {
    title: 'Network & Data Security',
    items: [
      {
        title: 'SSL',
        text: [
          'All applications on our network are secured via SSL. ',
          'Our SSL certificates receive an A+ rating when tested on Qualys SSL Labs.'
        ]
      },
      {
        title: 'Customer data',
        text: [
          'All data captured by or shared with MikMak is encrypted in transition and at rest.  This data is also secured behind two factor authentication, and only relevant team members are given access.'
        ]
      },
      {
        title: 'GDPR compliance',
        text: [
          'In MikMak experiences that allow users to submit PII, we work to ensure that these versions of our applications are GDPR compliant.'
        ]
      },
      {
        title: 'Backups & Physical protection',
        text: [
          'All MikMak code and data is backed up on cloud storage services, with several layers of redundancy to protect against unexpected incidents.',
          'MikMak data is spread across several regions in order to ensure reliable backup in the event of a natural disaster in a specific region.'
        ]
      }
    ]
  },
  {
    title: 'Team security',
    items: [
      {
        title: 'Employee and Contractor policy',
        text: [
          'All MikMak employees and contractors are given onboarding materials to ensure that they (and their devices) comply with our security guidelines.'
        ]
      },
      {
        title: 'Devices & Encryption',
        text: [
          'All devices used by MikMak team members use encryption and password protection to ensure data is only available to authorized team members.'
        ]
      },
      {
        title: 'Audits',
        text: [
          'MikMak performs monthly audits to ensure all team members and company devices are in compliance with our security guidelines.'
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./client/store/imports/Security.js